"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var dataItemStyle = 'tw-py-4 tw-pl-6 first:tw-pl-0';
var SkeletonTableBody = function (_a) {
    var _b = _a.columns, columns = _b === void 0 ? [] : _b, _c = _a.skeletonRowsCount, skeletonRowsCount = _c === void 0 ? 0 : _c, id = _a.id, _d = _a.rowClassName, rowClassName = _d === void 0 ? '' : _d;
    var skeletonRowsList = skeletonRowsCount ? Array(skeletonRowsCount).fill({}) : [];
    return (react_1.default.createElement(react_1.default.Fragment, null, skeletonRowsList === null || skeletonRowsList === void 0 ? void 0 : skeletonRowsList.map(function (_, index) {
        return (react_1.default.createElement("tr", { key: "skeleton_row_" + index, "data-testid": "table-body-skeleton-row-" + id, className: rowClassName }, columns === null || columns === void 0 ? void 0 : columns.map(function (column, columnIndex) {
            var _a;
            return (react_1.default.createElement("td", { key: "skeleton_column_" + columnIndex, className: ((_a = column === null || column === void 0 ? void 0 : column.className) !== null && _a !== void 0 ? _a : '') + " " + dataItemStyle, "data-testid": "table-body-skeleton-column-" + id }, column === null || column === void 0 ? void 0 : column.skeleton));
        })));
    })));
};
exports.default = SkeletonTableBody;
